<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EJ0P4H/tc-custom/9781429928946.jpg?1730579812780" alt="This image is the cover for the book Defining the World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Defining the World
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] marvelous account” of Johnson’s towering achievement, nearly a decade of labor and linguistic fact-finding, presented by “a buoyant, zestful writer” (<i>The </i><i>Boston Globe</i>).</b><br/><br/> By the early eighteenth century, France and Italy had impressive lexicons, but there was no authoritative dictionary of English. Impelled by a mixture of national pride and commercial expedience, the prodigious polymath Samuel Johnson embraced the task, turning over the garret of his London home to the creation of his own giant dictionary.<br/><br/> Johnson imagined that he could complete the job in three years. But the complexity of English meant that his estimate was wildly inadequate. Only after he had expended nearly a decade of his prime on the task did the dictionary finally appear—magisterial yet quirky, dogmatic but generous of spirit, and steeped in the richness of English literature. It would come to be seen as the most important British cultural monument of the eighteenth century, and its influence fanned out across Europe and throughout Britain’s colonies—including, crucially, America.<br/><br/> Brilliantly entertaining and enlightening,<i> Defining the World</i> is the story of Johnson’s heroic endeavor. In alphabetically sequenced chapters, Henry Hitchings describes Johnson’s adventure—his ambition and vision, his moments of despair, the mistakes he made along the way, and his ultimate triumph. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Hitchings
      </h2>
      
      <p class="authorDescription body article"><P><B>Henry Hitchings</B> received his Ph.D from University College, London. He has written for numerous newspapers and periodicals, including the <I>Times Literary Supplement</I>, the <I>Observer</I>, the <I>New Statesman</I> and the <I>Financial Times</I>. <I>Defining the World</I> is his first book. He lives in London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53cdd9d5